export default __webpack_public_path__ + "static/339-73d85cd650f6a1d44c8e02ba3a3076be.gif";